// src/services/tokenWatcher.ts
import { TokenService } from './tokenService';

class TokenWatcher {
  private static instance: TokenWatcher;
  private watcherInterval: number | null = null;
  private readonly CHECK_INTERVAL = 10 * 60 * 1000; // 10 minutes

  private constructor() {}

  public static getInstance(): TokenWatcher {
    if (!TokenWatcher.instance) {
      TokenWatcher.instance = new TokenWatcher();
    }
    return TokenWatcher.instance;
  }

  public startWatching(): void {
    if (this.watcherInterval) {
      this.stopWatching();
    }

    this.watcherInterval = window.setInterval(() => {
      this.checkTokens();
    }, this.CHECK_INTERVAL);

    // Check immediately
    this.checkTokens();
  }

  public stopWatching(): void {
    if (this.watcherInterval) {
      window.clearInterval(this.watcherInterval);
      this.watcherInterval = null;
    }
  }

  private checkTokens(): void {
    const refreshToken = TokenService.getRefreshToken();

    if (!refreshToken) {
      this.stopWatching();
      return;
    }

    // If refresh token expired, logout
    if (TokenService.isTokenExpired(refreshToken)) {
      console.log('[TokenWatcher] Refresh token expired, logging out...');
      this.handleExpiredToken();
    }
  }

  private handleExpiredToken(): void {
    this.stopWatching();
    TokenService.clearAll();

    if (window.location.pathname !== '/login') {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
      window.location.href = '/login';
    }
  }
}
export default TokenWatcher;
